<script>
import { onMount } from "svelte";
import Address from "./Components/Address.svelte"
import { options } from "./config";

import { GetContact, PostContact } from "./Services/form0";
import { user } from "./store";
import { loading } from "./loader";
import LoggedIn from "./Components/Auth/LoggedIn.svelte";
    
    export let data = {
        profile:options.profile,
        form:"create_customer",
        data:{
            address:{}
        }
    }
    loading.set(true)
    export let params = {}
    onMount(()=>{
        if(params.customer){
            GetContact(options.profile,"customer/"+params.customer,$user.idToken,(d)=>{
                data = d
                data.data.address = data.data.address||{}
                loading.set(false)
            })
        }else{
            loading.set(false)
        }
    })

    const save = ()=>{
        loading.set(true)
        PostContact(data,$user.idToken,(d)=>{
            data=d

            loading.set(false)
        },(error)=>{
            loading.set(false)
            console.error(error)
        })
    }
</script>
<LoggedIn/>
<div class="section_wrapper">
        <div class="s s50 box">
            <div class="content_area">
                <div class="s s33">
                    <label>Active</label>
                    <input type="checkbox" bind:checked={data.data.active}>
                </div>
                <div class="s s100">
                    <input placeholder="Name" type="text" bind:value={data.data.name}>
                </div>
                <div class="s s100">
                    <label>base2 Lead</label>
                    <textarea type="text" bind:value={data.data.base2Lead} placeholder="Lead"></textarea>
                </div>
                <div class="s s100">
                    <label>base2 Contacts</label>
                    <textarea type="text" bind:value={data.data.base2Contacts} placeholder="Lead"></textarea>
                </div>
                <div class="s s100">
                    <label>Customer Contacts</label>
                    <textarea type="text" bind:value={data.data.leads} placeholder="Customer Lead"></textarea>
                </div>
            </div>
        </div>
        <div class="s s50">
            <div class="s s100 box">
                <div class="content_area">
                <Address bind:address={data.data.address}/>
                </div>
            </div>
           
            <div class="s s100 box text_right">
                <div id="form_submit" on:click={save} class="brand-link">Save</div>
            </div>
        </div>
        
     
</div>